import React from "react"
import moment from "moment"
import { FormattedMessage } from "react-intl"
import { Divider, Modal } from "@walmart-web/livingdesign-components"
import AutoHide from "components/Shared/AutoHide/AutoHide"
import Button from "components/Shared/Button"
import { ReactComponent as Logo } from "assets/images/logo-phronesis-color.svg"
import { useApplicationContext } from "context/applicationContext"
import "./index.scss"

const START_DATE = moment("2025-04-29").toDate()
const END_DATE = moment("2025-05-31").toDate()

const Welcome: React.FC = () => {
	const { welcomeMessage, setWelcomeMessage } = useApplicationContext()
	const isVisible = localStorage.getItem("welcomeMessage") !== "false"

	const onClick = () => {
		setWelcomeMessage(false)
		localStorage.setItem("welcomeMessage", "false")
	}

	return (
		<AutoHide isVisible={isVisible} start={START_DATE} end={END_DATE}>
			<Modal
				isOpen={welcomeMessage}
				title={<FormattedMessage id="phronesis.welcome.title" />}
				onClose={onClick}
				size="medium"
				UNSAFE_className="phronesis-welcome-modal"
			>
				<div className="phronesis-welcome-modal-container">
					<Logo className="phronesis-welcome-modal-logo" />
					<FormattedMessage id="phronesis.welcome.body">
						{(message) => (
							<div className="phronesis-welcome-modal-body">{message}</div>
						)}
					</FormattedMessage>
					<Divider />
					<Button
						variant="primary"
						UNSAFE_className="phronesis-welcome-modal-button"
						onClick={onClick}
					>
						<FormattedMessage id="phronesis.welcome.button" />
					</Button>
				</div>
			</Modal>
		</AutoHide>
	)
}

export default Welcome
